import { Box } from '@chakra-ui/react';
import { FingerNote } from '../../Finger/FingerNote';
import { Status } from './types';
import { useTranslation } from "react-i18next";

type Props = {
  status: Status;
  reason?: string;
  description?: string;
  children?: React.ReactNode;
  deletedByTTL?: boolean;
};

const RenderDocInfo = ({ status, reason, description, children, deletedByTTL }: Props) => {
    const { t } = useTranslation('common');
  if (deletedByTTL) {
    return (
      <Box fontWeight="medium" mb={1}>
        {t('common:deletedAsPerTheDataDeletionSched')}
                  </Box>
    );
  }

  if (children || reason || description || status === Status.UploadedError) {
    return (
      <>
        {children}

        {reason && <FingerNote title={t('common:reasonForDocumentRejection')} description={reason} />}

        {description && <FingerNote title={t('common:customDocumentRequest')} description={description} />}
      </>
    );
  }

  return null;
};

export default RenderDocInfo;
